import React, { FunctionComponent, ReactType } from 'react';

// types
import { AccessFee } from 'ducks/merchantDucks/items/types';

// components
import AssetPreview from 'components/PaywallPreviews/AssetPreview';
import LoginScreen from 'components/PaywallPreviews/LoginScreen';
import { Branding } from 'pages/MerchantPages/Settings/Branding/components/Preview';
import Loader from 'components/Loader';
import { AccessControlType } from 'ducks/merchantDucks/accesses/actions';
import CodeAccessScreen from './CodeAccessScreen';
import PriceOptionsScreen from './PriceOptionsScreen';
import DataCaptureScreen from './DataCaptureScreen';

interface Props {
  previewIndex: number;
  branding?: Branding;
  accessFees?: Array<AccessFee>;
  assetCountrySetId: number;
  assetDomainRestrictions: Array<any>;
  displayBuyButton?: boolean;
  width?: string;
  height?: string;
  previewTemplateId: number | null;
  accessControlTypeId: number;
  isTemplate?: boolean;
}

interface ComponentData {
  branding?: Branding;
  accessFees?: Array<AccessFee>;
  assetCountrySetId: number;
  assetDomainRestrictions: Array<any>;
  displayBuyButton?: boolean;
  width?: string;
  height?: string;
  previewTemplateId?: number | null;
}

const accessTypes: { [key: number]: ReactType } = {
  [AccessControlType.PAID]: AssetPreview,
  [AccessControlType.CODEONLY]: CodeAccessScreen,
  [AccessControlType.DATA]: LoginScreen,
  [AccessControlType.DATACAPTURE]: DataCaptureScreen,
  5: PriceOptionsScreen,
  [AccessControlType.CODEAUTH]: CodeAccessScreen,
};

const PaywallPreview: FunctionComponent<Props> = ({ previewIndex, previewTemplateId, ...otherProps }) => {
  if (previewIndex === 0) {
    return <Loader position="absolute" />;
  }

  const componentProps: ComponentData = otherProps;
  if (previewTemplateId) {
    componentProps.previewTemplateId = previewTemplateId;
  }

  const PaywallPreviewComponent = accessTypes[previewIndex]!;
  return <PaywallPreviewComponent {...componentProps} />;
};

export default PaywallPreview;
